/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GroundingDataType = {
    SharePointKnowledgeBase: 'SharePointKnowledgeBase',
    BlobKnowledgeBase: 'BlobKnowledgeBase',
    Bing: 'Bing',
    ChatFile: 'ChatFile'
} as const;
export type GroundingDataType = typeof GroundingDataType[keyof typeof GroundingDataType];


export function instanceOfGroundingDataType(value: any): boolean {
    for (const key in GroundingDataType) {
        if (Object.prototype.hasOwnProperty.call(GroundingDataType, key)) {
            if (GroundingDataType[key as keyof typeof GroundingDataType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GroundingDataTypeFromJSON(json: any): GroundingDataType {
    return GroundingDataTypeFromJSONTyped(json, false);
}

export function GroundingDataTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroundingDataType {
    return json as GroundingDataType;
}

export function GroundingDataTypeToJSON(value?: GroundingDataType | null): any {
    return value as any;
}

export function GroundingDataTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): GroundingDataType {
    return value as GroundingDataType;
}

